import { useState, useEffect } from 'react';
import Ellipsis from "./components/ellipsis";
import Icon from './components/icon';
export * from './interface';
export const transformColorByPercent = (originColor, percent) => {
    return `${originColor === null || originColor === void 0 ? void 0 : originColor.slice(0, -1)},${percent})`;
};
export const useElementConfig = (selectedElement) => {
    const [config, setConfig] = useState(selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.getConfig());
    useEffect(() => {
        selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.onConfigChange(setConfig);
        return () => {
            selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.offConfigChange(setConfig);
        };
    }, []);
    return [config, selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.setConfig];
};
// export const useDataConfig = (selectedElement: BaseNode) => {
//   const [data, setData] = useState(selectedElement?.getData());
//   useEffect(()=>{
//     selectedElement?.onDataChange(setData);
//     return ()=>{
//       selectedElement?.offDataChange(setData);
//     }
//   },[]);
//   return [data, selectedElement?.setData];
// };
export { Ellipsis, Icon };
//# sourceMappingURL=index.js.map